
  import createMeisterIcons from '../src/createMeisterIcons';

  const KeyStraight = createMeisterIcons("key-straight", [["path",{"fill":"currentColor","d":"M3.75 12a2.85 2.85 0 1 1 5.7 0 2.85 2.85 0 0 1-5.7 0M6.6 7.65a4.35 4.35 0 1 0 4.286 5.1h5.564v1.65a.75.75 0 0 0 1.5 0v-1.65h2.3v2.85a.75.75 0 0 0 1.5 0v-4.9a.75.75 0 0 0-1.5 0v.55h-9.364A4.35 4.35 0 0 0 6.6 7.65","key":"f9fb6f9067eb847a225aeece2769fa889fae85e3","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default KeyStraight
  